export default __webpack_public_path__ + "static/Web-camera-amazon-main-diagram-EN-7-98b6762b6efcda57f79f73b790def1ae.webp";